import { render, staticRenderFns } from "./recbuydri.vue?vue&type=template&id=3aa82252&scoped=true&"
import script from "./recbuydri.vue?vue&type=script&lang=js&"
export * from "./recbuydri.vue?vue&type=script&lang=js&"
import style0 from "./recbuydri.vue?vue&type=style&index=0&id=3aa82252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa82252",
  null
  
)

export default component.exports